import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./app/App";
import "./styles/base.css";

const container = document.getElementById("root");
if (!container) throw new Error("root element is missing from index.html");

createRoot(container).render(
  <StrictMode>
    {/* React Router v7: v7_startTransition and v7_relativeSplatPath are the
        default behaviours, so the router behaves the same in tests and in
        the browser without feature flags. */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
